module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/pricing.40d2e7bd.svg";